import React from "react";
import { useNavigate, Link } from "react-router-dom"; // navigation hook
import Card from "../components/Card";
import { FaChartLine, FaMapMarkedAlt } from "react-icons/fa";
import "../design/Home.css"; // reuse the same grid & typography styles as the Home screen
import { Breadcrumb } from "antd";  


/**
 * Kentyou Data Visualisations screen
 * ---------------------------------
 * Mirrors the look‑and‑feel & card‑based navigation logic of the main Home page.
 * Provides two options:
 *   • Metrics  –> /kentyou-metrics
 *   • Map      –> /kentyou-map
 *
 * The routing destinations are placeholders; adjust the paths or swap in a
 * `window.open()` call if you prefer an external link (same pattern as the
 * Data Visualisation card on Home).
 */
const KentyouDataVisualisations = () => {
  const navigate = useNavigate();

  return (
    <>
    <div className="page-header">
        <div className="page-breadcrumb-wrapper">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/home">Home</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>KentyouEye Data Visualisations</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>
    <div className="home-container">
      <h1 className="home-title">KentyouEye Data Visualisations</h1>

      <div className="card-grid">
        {/* Metrics card */}
        <Card
          icon={<FaChartLine />}  // bar‑chart‑like icon
          title="Metrics"
          onClick={() => navigate("/kentyoueye")}
        />

        {/* Map card */}
        <Card
          icon={<FaMapMarkedAlt />}  // map pin icon
          title="Map"
          onClick={() => navigate("/map")}
        />
      </div>
    </div></>
  );
};

export default KentyouDataVisualisations;
